import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import * as _ from 'lodash';

import { CONSTANT_VALUES } from '../../constants/constant-values';
import { LoaderEvent } from './../../shared/message.event';

@Component({
    selector: 'app-disable-popup',
    templateUrl: './disable-popup.component.html',
    styleUrls: ['./disable-popup.component.css'],
    providers: [LoaderEvent],
    exportAs: 'disablePopupObj'
})
export class DisablePopupComponent implements OnInit {
    public disableObj;
    @ViewChild('childModal') childModal: ModalDirective;
    @Input() message = '';
    @Input() popupTitle;
    @Input() cancleButton;
    @Output() notify = new EventEmitter<boolean>();
    @Output() notifyDelete = new EventEmitter<boolean>();
    @Input() deleteMessage;
    @Output() disableFacility = new EventEmitter<any>();
    @Input() facilityList = [];
    private popUpMessage = '';
    private validate;
    private windowHeight = window.innerHeight;
    private topNav = 56;
    private midNav = 45;
    private footer = 35;
    private container = 40;
    private height: any;
    private disableStartTime = '';
    private disableEndTime = '';
    private startMaxDate;
    private endMinDate = new Date();
    private minDate = new Date();
    private selectedFacilityId;

    constructor(private loaderEvent: LoaderEvent) {
        this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer)) + 'px';
        this.validate = {
            facility: '',
            flag: true,
            reason: '',
            startTime: '',
            endTime: ''
        };
        this.disableObj = {
            facility: '',
            reason: '',
            startTime: '',
            endTime: ''

        };
    }


    public showChildModal(): void {
        try {
            this.removeValidatorClass();
            this.selectedFacilityId = '';
            this.disableObj.facility = '';
            this.disableStartTime = '';
            this.disableEndTime = '';
            this.disableObj.reason = '';
            this.startMaxDate = '';
            this.endMinDate = new Date();
            this.minDate = new Date();
            this.childModal.config.backdrop = false;
            this.childModal.show();
        } catch (e) {
            console.log(e);
        }
    }

    public hideChildModal(): void {
        try {
            this.childModal.hide();
        } catch (e) {
            console.log(e);
        }
    }

    ngOnInit() {
    }

    /**
     * Emit object to disable specific facility.
     */
    onClickOk(popupObj) {
        try {
            let start, end;
            if (this.disableStartTime && this.disableEndTime) {
                start = new Date(this.disableStartTime).setHours(0, 0, 0, 0);
                end = new Date(this.disableEndTime).setHours(24, 0, 0, 0);
                this.disableObj.startTime = new Date(start).toISOString();
                this.disableObj.endTime = new Date(end).toISOString();
            }
            let response = this.validateTime();
            if (response.flag) {
                if (this.validate.flag) {
                    this.disableObj.facility = _.find(this.facilityList, { '_id': this.selectedFacilityId });
                    this.disableFacility.emit(this.disableObj);
                    this.hideChildModal();
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    onClickCancel() {
        try {
            this.notify.emit(false);
        } catch (e) {
            console.log(e);
        }
    }

    /**
    * Validate on select facility
    */
    onFacilityChange(facilityId) {
        this.selectedFacilityId = this.getSanitizedFacilityId(facilityId);
        if (this.selectedFacilityId === '') {
            this.validate.facility = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        } else {
            this.validate.facility = '';
        }
    }

    /**
     * Validate on reason
     */
    onReasonChange() {
        if (this.disableObj.reason === '') {
            this.validate.reason = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        } else {
            this.validate.reason = '';
        }
    }

    /**
     * Validate on start date
     */
    onSelectStartDate() {
        if (this.disableStartTime) {
            this.validate.startTime = '';
        } else {
            this.validate.startTime = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.startTime = 'required';
            this.validate.flag = false;
        }
    }

    /**
     * Validate on end date
     */
    onSelectEndDate() {
        if (this.disableEndTime) {
            this.validate.endTime = '';
        } else {
            this.validate.endTime = 'required';
            this.validate.endTime = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        }
    }

    /**
     * Get facility id.
     */
    getSanitizedFacilityId(facilityId) {
        let sanitizedFacilityId = "";
        if (facilityId && (facilityId + '').indexOf(':') > -1) {
            sanitizedFacilityId = facilityId.split(':')[1].trim();
        }
        return sanitizedFacilityId;
    }

    changeEndMinDate(startDate) {
        this.disableEndTime = this.disableStartTime
        this.endMinDate = startDate;
    }
    /**
     * Validation on all fields
     */
    validateTime() {
        this.validate.flag = true;
        let response = {
            flag: true,
            message: ''
        };
        if (this.selectedFacilityId === '') {
            this.validate.facility = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        }
        if (!this.disableStartTime) {
            this.validate.startTime = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        }
        if (!this.disableEndTime) {
            this.validate.endTime = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        }
        if (!(this.disableObj.reason + '').trim()) {
            this.validate.reason = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        }
        return response;
    }
    /**
     * Set start and end date
     * 
     * @param {any} minEndDate 
     * 
     * @memberof DisablePopupComponent
     */
    changeStartEndDate(minEndDate) {
        this.startMaxDate = minEndDate;
    }
    removeValidatorClass() {
        this.validate.facility = '';
        this.validate.startTime = '';
        this.validate.endTime = '';
        this.validate.reason = ''
    }
}



// WEBPACK FOOTER //
// ./src/app/member/disable-popup/disable-popup.component.ts